<template>
  <div class="editAdd">
    <p>接手人</p>
    <article class="personinfofill">
      <ul>
        <li>
          <p>
            <span>*</span>
            姓名:
          </p>
          <input
            type="text"
            placeholder="请输入接手人姓名"
            maxlength="15"
            v-model="name"
            @input="handlechange('name')"
          />
        </li>
        <li>
          <p>
            <span>*</span>
            手机号:
          </p>
          <input
            type="tel"
            maxlength="14"
            minlength="7"
            v-model="mobile"
            placeholder="请输入手机号码"
            class="input-code"
            ref="input"
          />
        </li>
        <li>
          <p>
            <span>*</span>
            身份证号:
          </p>
          <input
            type="text"
            maxlength="20"
            minlength="7"
            v-model="idcard"
            placeholder="请输入身份证号码"
            class="input-code"
            ref="input"
          />
        </li>
        <li>
          <p>
            <span>*</span>
            邮箱:
          </p>
          <input
            type="text"
            maxlength="20"
            minlength="7"
            v-model="email"
            placeholder="请输入邮箱"
            class="input-code"
            ref="input"
          />
        </li>
        <li>
          <p>银行卡号:</p>
          <input
            type="tel"
            minlength="7"
            v-model="bankcardid"
            placeholder="请输入接手人银行卡号"
            class="input-code"
            ref="input"
          />
        </li>
        <li>
          <router-link :to="'/openingbank?1=1' + arg">
            <div>
              <p>开户银行:</p>
              <input
                type="text"
                readonly
                v-model="bankname"
                placeholder="请输入开户银行"
                @input="handlechange('bankname')"
                class="input-code"
                ref="input"
              />
            </div>

            <img src="../../assets/images/jt3.png" />
          </router-link>
        </li>
      </ul>
      <div class="mask" v-if="info.stage != 6 && info.stage != 7 && info.stage != 9"></div>
    </article>
    <p>接手人身份证照片</p>
    <article class="idcard">
      <ul>
        <li>
          <van-uploader v-model="portrait">
            <img v-if="!portrait.length" src="/static/images/storechange/portrait.png" />
            <img v-if="portrait.length" src="/static/images/storechange/portrait1.png" />
            <div class="content">
              <img v-if="portrait.length" :src="portrait[0].content" />
            </div>
          </van-uploader>
        </li>
        <li>
          <van-uploader v-model="idcardback">
            <img v-if="!idcardback.length" src="/static/images/storechange/idcardback.png" />
            <img v-if="idcardback.length" src="/static/images/storechange/idcardback1.png" />
            <div class="content">
              <img v-if="idcardback.length" :src="idcardback[0].content" />
            </div>
          </van-uploader>
        </li>
        <li>
          <van-uploader v-model="idcardfront">
            <img v-if="!idcardfront.length" src="/static/images/storechange/idcardfront.png" />
            <img v-if="idcardfront.length" src="/static/images/storechange/idcardfront1.png" />
            <div class="content">
              <img v-if="idcardfront.length" :src="idcardfront[0].content" />
            </div>
          </van-uploader>
        </li>
        <!--        <li>-->
        <!--          <img src="/static/images/storechange/portrait1.png">-->
        <!--          <div class="content">-->
        <!--            <img :src="info.idcardfront">-->
        <!--          </div>-->
        <!--        </li>-->
        <!--        <li>-->
        <!--          <img src="/static/images/storechange/portrait1.png">-->
        <!--          <div class="content">-->
        <!--            <img :src="info.idcardback">-->
        <!--          </div>-->
        <!--        </li>-->
        <!--        <li>-->
        <!--          <img src="/static/images/storechange/portrait1.png">-->
        <!--          <div class="content">-->
        <!--            <img :src="info.idcardhand">-->
        <!--          </div>-->
        <!--        </li>-->
      </ul>
    </article>
    <footer>
      <button class="btn" @click="submit">重新提交</button>
    </footer>
  </div>
</template>

<script>
import { isWeixin, fenxiang, isApp } from '../../assets/common/js/config'
import wx from 'weixin-js-sdk'

export default {
  name: 'identityauthsucc',
  data() {
    return {
      name: '',
      mobile: '',
      idcard: '',
      email: '',
      bankcardid: '',
      bankname: '',
      banknamechooseitem: null,
      portrait: [],
      idcardback: [],
      idcardfront: [],
      datalist: [],
      arg: isApp()
    }
  },
  mounted: function () {
    if (isWeixin()) {
      fenxiang({ path: 'identityauthsucc' })
    }
    this.getData()
  },
  destroyed: function () {
    this.$toast.clear()
    this.$dialog.close()
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.banknamechooseitem = sessionStorage.getItem('bank_name_choose_item')
        ? JSON.parse(sessionStorage.getItem('bank_name_choose_item'))
        : null
      if (vm.banknamechooseitem && vm.banknamechooseitem.name)
        vm.bankname = vm.banknamechooseitem.name
    })
  },
  watch: {
    mobile(n) {
      this.$nextTick(() => {
        // 这里
        this.mobile = String(n).replace(/\D/g, '')
      })
    },
    portrait(n) {
      if (n.length > 1) {
        this.portrait.splice(0, 1)
      }
    },
    idcardback(n) {
      if (n.length > 1) {
        this.idcardback.splice(0, 1)
      }
    },
    idcardfront(n) {
      if (n.length > 1) {
        this.idcardfront.splice(0, 1)
      }
    }
  },
  methods: {
    getData: function () {
      var url = this.$ajax.getChangeBase_URL + '?applyid=' + this.$route.query.storeid
      this.$customRequestAjax(url).then((res) => {
        if (res.data.code == 200) {
          this.info = res.data.data
          this.name = this.info.name
          this.mobile = this.info.mobile
          this.idcard = this.info.idcard
          this.email = this.info.email
          this.bankcardid = this.info.bankcardid
          this.bankname = this.info.bankname
          this.portrait.push({
            content: this.info.idcardfront
          })
          this.idcardback.push({
            content: this.info.idcardback
          })
          this.idcardfront.push({
            content: this.info.idcardhand
          })
        }
      })
    },
    // 将base64转换为blob
    dataURLtoBlob: function (dataurl) {
      var arr = dataurl.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new Blob([u8arr], { type: mime })
    },
    // 将blob转换为file
    blobToFile: function (theBlob, fileName) {
      theBlob.lastModifiedDate = new Date()
      theBlob.name = fileName
      return theBlob
    },
    random_string: function (n) {
      var num = Math.pow(10, n)
      return Math.ceil(Math.random() * num) + '' + new Date().getTime()
    },
    // 2024.3.18阿里云迁移-对象存储-上传图片视频调整-4 Mod by gaoenhui Start
    cosUploadImage(filllist, file, index, format, type, fn) {
      console.log(file)
      if (
        (file.url && file.url.indexOf('https://') >= 0) ||
        (file.content && file.content.indexOf('https://') >= 0)
      ) {
        index++
        var path = file.url
          ? file.url.replace('Uploads/', '')
          : file.content.replace('Uploads/', '')
        if (type == 'imgpath') {
          path = file.url ? file.url.split('Uploads/')[1] : file.content.split('Uploads/')[1]
        } else {
          path = file.content
        }
        if (type == 'imgpath') {
          this.datalist.push(path)
        }
        if (index >= filllist.length) {
          if (typeof fn === 'function') {
            fn()
          }
        }
        return
      }
      var that = this
      that.$cos.uploadFile({
        key: '/identityauthsucc_h5' + file.file.name,
        file: file.file,
        success: function (data) {
          if (type == 'imgpath') {
            that.datalist.push(data)
          }
          index++
          if (index >= filllist.length) {
            if (typeof fn === 'function') {
              fn()
            }
          }
        }
      })
    },
    // 2024.3.18阿里云迁移-对象存储-上传图片视频调整-4 Mod by gaoenhui End
    uploadImage(filllist, file, index, format, type, fn) {
      if (
        (file.url && file.url.indexOf('https://') >= 0) ||
        (file.content && file.content.indexOf('https://') >= 0)
      ) {
        index++
        var path = file.url
          ? file.url.replace('Uploads/', '')
          : file.content.replace('Uploads/', '')
        if (type == 'imgpath') {
          path = file.url ? file.url.split('Uploads/')[1] : file.content.split('Uploads/')[1]
        } else {
          path = file.content
        }
        if (type == 'imgpath') {
          this.datalist.push(path)
        }
        if (index >= filllist.length) {
          if (typeof fn === 'function') {
            fn()
          }
        }
        return
      }
      var imgName = 'idcard'
      var blob = this.dataURLtoBlob(file.content)
      var newFile = this.blobToFile(blob, imgName)
      var url = this.$ajax.getOssWeb_URL
      var that = this
      this.$customRequestAjax(url).then(async (res) => {
        if (res.data.code === 200) {
          const { accessid, host, policy, signature, dir } = res.data.data
          const fd = new FormData()
          let str = that.random_string(16) + newFile.name + format
          fd.append('OSSAccessKeyId', accessid)
          fd.append('policy', policy)
          fd.append('Signature', signature)
          fd.append('key', `${dir}${str}`)
          fd.append('Filename', `${dir}${str}`)
          fd.append('success_action_status', 200)
          fd.append('file', newFile)
          let config = {
            // 添加请求头
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
          that.$axios.post(host, fd, config).then((res) => {
            if (res.status == 200 && res.statusText == 'OK') {
              // var img = that.imgUrl + `${dir}${str}`
              var path = `${dir}${str}`.replace('Uploads/', '')
              if (type == 'imgpath') {
                that.datalist.push(path)
              }
              index++
              if (index >= filllist.length) {
                if (typeof fn === 'function') {
                  fn()
                }
              }
            }
          })
        }
      })
    },
    submit: function () {
      // portrait
      // idcardback
      // idcardfront
      if (this.name.trim().replace(/ /g, '') == '' || this.name == undefined || this.name == null) {
        this.$toast('接手人姓名不能为空')
        return
      } else if (
        this.mobile.trim().replace(/ /g, '') == '' ||
        this.mobile == undefined ||
        this.mobile == null
      ) {
        this.$toast('手机号码不能为空')
        return
      } else if (
        this.idcard.trim().replace(/ /g, '') == '' ||
        this.idcard == undefined ||
        this.idcard == null
      ) {
        this.$toast('身份证号码不能为空')
        return
      } else if (
        this.email.trim().replace(/ /g, '') == '' ||
        this.email == undefined ||
        this.email == null
      ) {
        this.$toast('邮箱不能为空')
        return
      } else if (!/^1[3456789]\d{9}$/.test(this.mobile)) {
        this.$toast('手机号码有误，请重填')
        return
      } else if (!this.portrait.length) {
        this.$toast('请上传人像面')
        return
      } else if (!this.idcardback.length) {
        this.$toast('请上传国徽面')
        return
      } else if (!this.idcardfront.length) {
        this.$toast('请上传身份证手持照')
        return
      }
      this.$toast.loading({
        mask: true,
        message: '正在提交',
        duration: 0
      })
      this.fileLen = 0
      this.datalist = []
      var that = this
      // 2024.3.18阿里云迁移-对象存储-上传图片视频调整-4 Mod by gaoenhui Start
      that[that.$cos.isCosSwitch == 1 ? 'cosUploadImage' : 'uploadImage'](
        that.portrait,
        that.portrait[that.fileLen],
        that.fileLen,
        '.png',
        'imgpath',
        function () {
          that.fileLen = 0
          that[that.$cos.isCosSwitch == 1 ? 'cosUploadImage' : 'uploadImage'](
            that.idcardback,
            that.idcardback[that.fileLen],
            that.fileLen,
            '.png',
            'imgpath',
            function () {
              that.fileLen = 0
              that[that.$cos.isCosSwitch == 1 ? 'cosUploadImage' : 'uploadImage'](
                that.idcardfront,
                that.idcardfront[that.fileLen],
                that.fileLen,
                '.png',
                'imgpath',
                function () {
                  that.submitAxios()
                }
              )
            }
          )
        }
      )
      // 2024.3.18阿里云迁移-对象存储-上传图片视频调整-4 Mod by gaoenhui End
    },
    submitAxios: function () {
      var url = this.$ajax.setMeinfo_URL,
        data = {
          type: this.$route.query.storetype,
          id: this.$route.query.storeid,
          name: this.name,
          mobile: this.mobile,
          idcard: this.idcard,
          email: this.email,
          bankcardid: this.bankcardid,
          bankname: this.bankname,
          idcardfront: this.datalist[0],
          idcardback: this.datalist[1],
          idcardhand: this.datalist[2]
        },
        arg = isApp(),
        that = this
      this.$customRequestAjax.post(url, data).then((res) => {
        if (res.data.code == 200) {
          this.$toast.clear()
          this.$dialog.close()
          this.$toast(res.data.msg)
          setTimeout(function () {
            if (arg == '') {
              that.$router.go(-1)
            } else if (arg.indexOf('xcx') >= 0) {
              wx.miniProgram.navigateBack()
            }
          }, 500)
        }
      })
    },
    input_blur() {
      // document.body.scrollTop = document.documentElement.scrollTop - 1
      setTimeout(() => {
        var scrollHeight = document.documentElement.scrollTop || document.body.scrollTop || 0
        window.scrollTo(0, Math.max(scrollHeight, 0))
      }, 100)
    },
    handlechange(n) {
      var reg =
        /[^\u0020-\u007E\u00A0-\u00BE\u2E80-\uA4CF\uF900-\uFAFF\uFE30-\uFE4F\uFF00-\uFFEF\u0080-\u009F\u2000-\u201f\u2026\u2022\u20ac\r\n]/g
      if (this[n].match(reg)) {
        this[n] = this[n].replace(reg, '')
      }
      this[n] = this[n].replace(/\s+/g, '')
    }
  }
}
</script>

<style scoped lang="scss">
.editAdd {
  background: #ffffff;
  > p {
    height: 0.42rem;
    background: #f5f5f5;
    color: #333333;
    font-size: 0.15rem;
    line-height: 0.42rem;
    font-weight: 500;
    text-indent: 0.11rem;
  }
  .personinfofill {
    position: relative;
    .mask {
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
    }
    ul {
      padding: 0 0.1rem 0 0.15rem;
      background: #fff;
      li {
        display: flex;
        align-items: center;
        height: 0.45rem;
        border-bottom: 0.005rem solid #d8d8d8;
        &:last-of-type {
          width: 100%;
          border-bottom-width: 0;
          a {
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;
            flex: 1;
          }
          div {
            display: flex;
            align-items: center;
            flex: 1;
          }
          img {
            float: left;
            width: 0.1rem;
            height: 0.1rem;
            padding: 0 0.02rem 0;
            margin-top: 0.04rem;
            margin-left: 0.07rem;
          }
        }
        p {
          font-size: 0.14rem;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
          line-height: 0.2rem;
          width: 0.82rem;
          span {
            color: red;
            padding-right: 0.05rem;
          }
        }
        input {
          border: none;
          outline: none;
          display: block;
          font-size: 0.14rem;
          color: #333;
          flex: 1;
          &::placeholder {
            color: #b7b7b7;
            font-size: 0.14rem;
          }
        }
      }
    }
  }
  .idcard {
    ul {
      padding: 0.1rem 0 0.55rem;
      background: #fff;
      li {
        text-align: center;
        font-size: 0;
        margin-bottom: 0.15rem;
        height: 1.62rem;
        position: relative;
      }
    }
  }
  footer {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    height: 0.63rem;
    padding: 0.1rem 0.11rem;
    .btn {
      border: 0;
      outline: none;
      border-radius: 0.25rem;
      display: block;
      font-size: 0.17rem;
      color: #ffffff;
      width: 100%;
      height: 100%;
      background: linear-gradient(90deg, #fc0324, #f63a66);
      background: -webkit-linear-gradient(90deg, #fc0324, #f63a66);
      background: -o-linear-gradient(90deg, #fc0324, #f63a66);
      background: -moz-linear-gradient(90deg, #fc0324, #f63a66);
      background: -ms-linear-gradient(90deg, #fc0324, #f63a66);
    }
  }
}
</style>
<style lang="scss">
.idcard {
  li {
    .content {
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      margin: auto;
      height: 0.87rem;
      width: 1.7rem;
      overflow: hidden;
      border-radius: 0.04rem;
      img {
        width: 100%;
      }
    }
    .van-uploader__preview {
      position: absolute;
      left: 0.1rem;
      top: 0.1rem;
    }
    .van-uploader__input-wrapper {
      width: 2.7rem;
      height: 1.62rem;
      img {
        width: 100%;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/storechange/identityauthsucc.vue